import "./swiper.scss"

import Swiper, { Autoplay, Navigation, Pagination, Thumbs } from "swiper"

Swiper.use([Autoplay, Navigation, Pagination, Thumbs, Autoplay])

window.Swiper = Swiper
